import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Directory of club id -> slug, for linking club names to /club/:slug pages.
 * Cached aggressively — slugs are stable.
 */
export const useClubSlugMap = () => {
  const { data } = useQuery({
    queryKey: ["club-slug-map"],
    queryFn: async () => {
      const map = new Map<string, string>();
      // Paginate in chunks to stay under PostgREST row limits
      let from = 0;
      const pageSize = 1000;
      for (;;) {
        const { data, error } = await supabase
          .from("clubs")
          .select("id, slug")
          .not("slug", "is", null)
          .range(from, from + pageSize - 1);
        if (error) break;
        (data || []).forEach((c) => {
          if (c.slug) map.set(c.id, c.slug);
        });
        if (!data || data.length < pageSize) break;
        from += pageSize;
      }
      return map;
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });

  const getClubSlug = (clubId: string | null | undefined): string | null =>
    clubId ? data?.get(clubId) ?? null : null;

  return { getClubSlug };
};
